import { defineMessages } from 'react-intl';

export const NewValuesStepContent = defineMessages({
  newSerialNumberLabel: {
    id: 'app.common.newSerialNumberLabel',
    defaultMessage: 'Sériové číslo nového měřidla',
  },
  newSerialNumberRequired: {
    id: 'app.common.newSerialNumberRequired',
    defaultMessage: 'Sériové číslo nového měřidla je povinné',
  },
  manufacturer: {
    id: 'app.common.manufacturer',
    defaultMessage: 'Výrobce',
  },
  meterModelLabel: {
    id: 'app.common.meterModelLabel',
    defaultMessage: 'Model měřidla',
  },
  manufacturedLabel: {
    id: 'app.Select.manufacturedLabel',
    defaultMessage: 'Rok výroby měřidla',
  },
  calibratedLabel: {
    id: 'app.Select.calibratedLabel',
    defaultMessage: 'Rok cejchování měřidla',
  },
  inbuiltOutputs: {
    id: 'app.common.inbuiltOutputs',
  },
  technology: {
    id: 'app.inventoryMeterOutput.technology',
  },
  remoteReadingOwner: {
    id: 'app.inventoryMeterOutput.remoteReadingOwner',
  },
  isOccupied: {
    id: 'app.inventoryMeterOutput.isOccupied',
  },
  installationStatus: {
    id: 'app.common.installationStatus',
    defaultMessage: 'Stav osazení',
  },
  installationStatusRequired: {
    id: 'app.common.installationStatusRequired',
    defaultMessage: 'Stav osazení je povinný',
  },
  installationStatusTooltip: {
    id: 'app.common.installationStatusTooltip',
    defaultMessage:
      'V jakém stavu je osazení měřidla.Pokud je měřidlo dálkově odečítáno, budeš muset upřesnit, kam tečou data',
  },
  meterMountTechnologyLabel: {
    id: 'app.common.meterMountTechnology',
    defaultMessage: 'Technologie osazení',
  },
  meterMountTechnologyTooltip: {
    id: 'app.common.meterMountTechnologyTooltip',
    defaultMessage: 'Jaká technologie osazení měřidla',
  },
  meterMountTechnologyPlaceholder: {
    id: 'app.common.selectValid',
    defaultMessage: 'Vyber platné',
  },
  protocolPhotosLabel: {
    id: 'app.common.protocolPhotosLabel',
    defaultMessage: 'Vyfocený protokol',
  },
  protocolPhotosRequired: {
    id: 'app.common.protocolPhotosRequired',
    defaultMessage: 'Musíš nahrát alespoň jednu fotku protokolu!',
  },
  detailPhotosHelp: {
    id: 'app.common.detailPhotosHelp',
    defaultMessage: 'Měřidlo vyfoť zblízka. Fotky by měly být dostatečně ostré.',
  },
  detailPhotosLabel: {
    id: 'app.common.detailPhotosLabel',
    defaultMessage: 'Fotky detail',
  },
  detailPhotosRequired: {
    id: 'app.common.detailPhotosRequired',
    defaultMessage: 'Musíš nahrát alespoň jednu fotku detailu měřidla!',
  },
  detailPhotosTooltip: {
    id: 'app.common.detailPhotosTooltip',
    defaultMessage:
      'Vyfoť důkladně detaily měřidla případně prostor kam by mělo být instalováno pokud se jedná o nový podružné měřidlo.',
  },
  registers: {
    id: 'app.common.registers',
    defaultMessage: 'Registry',
  },
  meterMountTechnology: {
    id: 'app.common.meterMountTechnology',
    defaultMessage: 'Technologie osazení',
  },
});

export const NewValuesStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Další',
  },
});
